import React from "react";

import WheelLoader from "../../assets/images/WheelLoader.png";
import ForkLift from "../../assets/images/ForkLift.png";
import BackHoe from "../../assets/images/Backhoe.png";
import GeneratorIcon from "../../assets/images/Generator.png";
import CraneHPC from "../../assets/images/Crane-HPC.png";
import CraneSafe from "../../assets/images/Crane-Safe.png";
import SkidSteerLoader from "../../assets/images/SkidSteerLoader.png";
import ExcavatorBasic from "../../assets/images/Excavator-Basic.png";
import LandingImage from "../../assets/images/pirentz-desktop-landing.png";
import GooglePlayBadge from "../../assets/images/google-play-badge.png";
import AppStoreBadge from "../../assets/images/app-store-badge.png";
import MobileLandingImage from "../../assets/images/pirentz-mobile-landing.png";

import "./home-landing.scss";

const HomeLanding = () => (
  <section className="landing_container">
    <div className="landing_sections">
      <div className="text_section">
        <div className="app_section">
          <h1 className="app_name">PiRentz</h1>
          <h2 className="app_subname">
            construction equipment rentals <br /> at your finger tips
          </h2>
          <p className="app_caption">made in india. made for india</p>
        </div>
        <div className="download_section_wrapper">
          <div className="download_section">
            <p className="download_text"><span className="download_text_title">PiRentz Hiring&nbsp;</span> App</p>
            <p className="download_text">(For Hiring Construction Equipment) &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
            <div className="download_links">
              <a
                href="https://apps.apple.com/in/app/pirentz-hiring/id1557201422"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={AppStoreBadge}
                  alt="PiRentz Hiring app"
                  className="download_icon"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.pirentz.hiringparty"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={GooglePlayBadge}
                  alt="PiRentz Hiring app"
                  className="download_icon"
                />
              </a>
            </div>
          </div>
          <div className="download_section" style={{marginLeft:"2%"}}>
            <p className="download_text"><span className="download_text_title">PiRentz Partner</span> App</p>
            <p className="download_text">(For Partners, to list your Machines for Rental)</p>
            <div className="download_links">
              <a
                href="https://apps.apple.com/in/app/pirentz-partner/id1557183623"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={AppStoreBadge}
                  alt="PiRentz Partner app"
                  className="download_icon"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.pirentz.machineowner"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={GooglePlayBadge}
                  alt="PiRentz Partner app"
                  className="download_icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="image_section">
        <img
          src={LandingImage}
          alt="PiRentz Landing icon"
          className="landing_image"
        />
        <img
          src={MobileLandingImage}
          alt="PiRentz Landing icon"
          className="mobile_landing_image"
        />
      </div>
    </div>
    <div className="services_icons">
      <img src={WheelLoader} alt="Wheel Loader" className="service_icon" />
      <img src={ForkLift} alt="Fork Lift" className="service_icon" />
      <img src={BackHoe} alt="Back Hoe" className="service_icon" />
      <img src={GeneratorIcon} alt="Generator" className="service_icon" />
      <img src={CraneHPC} alt="Crane HPC" className="service_icon" />
      <img src={CraneSafe} alt="Crane Safe" className="service_icon" />
      <img
        src={ExcavatorBasic}
        alt="Excavator Basic"
        className="service_icon"
      />
      <img
        src={SkidSteerLoader}
        alt="Skid Steer Loader"
        className="service_icon"
      />
    </div>
  </section>
);

export default HomeLanding;
